function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { getMenuInfo, deleteAllSaveSearch, deleteSaveSearch, addUserFavorite, deleteUserFavorite, removeFavourites
//@ts-ignore
} from "@services/publicUserAPI";
//@ts-ignore
import { saveSearch } from "@services/realEstateAPI";
//@ts-ignore
import { sendAgencyContactAsync } from "@services/agencyAPI";
//@ts-ignore
import { hashEmail } from "@utils/EmailUtils";
//@ts-ignore
import { encodeCookie, removeCookie } from "@utils/CookieUtils";
import { defineStore } from "pinia";
import { ref, computed } from "vue";
//@ts-ignore
import { sendConsultantRequestContact } from "@services/AuctionAPI";
var insertHashedEmailCookie = function insertHashedEmailCookie(email) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var hashedEmail;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return hashEmail(email);
        case 3:
          hashedEmail = _context.sent;
          window.dataLayer.push({
            "hashedEmail": hashedEmail,
            "event": "hashedEmailInserted"
          });
          /* We want always to have a single email in our cookie! */
          removeCookie(email);
          encodeCookie("hashedEmail", hashedEmail, 30, false);
          _context.next = 12;
          break;
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 9]]);
  }));
};
export var usePublicUserMenuStore = defineStore("publicUserMenuStoreId", function () {
  var name = ref("");
  var email = ref("");
  var mailConfirmed = ref(null);
  var favoriteIdList = ref([]);
  var requestsCounter = ref(0);
  var savedSearchesCounter = ref(0);
  var lastLoginDate = ref("");
  var publicUserId = ref(-1);
  var marketing = ref(false);
  var lastFavouriteModifiedId = ref(-1);
  var listingRequestsCount = ref(0);
  var favoritesCounter = computed(function () {
    return favoriteIdList.value.length;
  });
  var getFavoriteById = function getFavoriteById(id) {
    return favoriteIdList.value.findIndex(function (_id) {
      return _id === id;
    });
  };
  var initState = function initState(_publicUserMenuInfo) {
    publicUserId.value = _publicUserMenuInfo.publicUserId;
    favoriteIdList.value = _publicUserMenuInfo.favouriteIdList;
    mailConfirmed.value = _publicUserMenuInfo.mailConfirmed;
    name.value = _publicUserMenuInfo.name;
    savedSearchesCounter.value = _publicUserMenuInfo.saveSearchCount;
    requestsCounter.value = _publicUserMenuInfo.sentRequestsCount;
    lastLoginDate.value = _publicUserMenuInfo.lastLoginDate;
    email.value = _publicUserMenuInfo.email;
    listingRequestsCount.value = _publicUserMenuInfo.listingRequestsCount;
    //@ts-ignore
    marketing.value = _publicUserMenuInfo.marketing;
    /* Adding the email to GTM */
    window.dataLayer.push({
      "email": email.value
    });
    /* Adding cookie */
    insertHashedEmailCookie(email.value);
  };
  var setMarketing = function setMarketing(newVal) {
    marketing.value = newVal;
  };
  var setSavedSearches = function setSavedSearches(newVal) {
    savedSearchesCounter.value = newVal;
  };
  var increaseSavedSearches = function increaseSavedSearches() {
    savedSearchesCounter.value = savedSearchesCounter.value + 1;
  };
  var decreaseSavedSearchesCounter = function decreaseSavedSearchesCounter() {
    savedSearchesCounter.value = savedSearchesCounter.value - 1;
  };
  var decreaseListingRequestsCounter = function decreaseListingRequestsCounter() {
    listingRequestsCount.value = listingRequestsCount.value - 1;
  };
  var setUserFavorite = function setUserFavorite(newVal) {
    favoriteIdList.value = newVal;
  };
  var increaseRequestCounter = function increaseRequestCounter() {
    requestsCounter.value = requestsCounter.value + 1;
  };
  //TODO: questa reset la si può sovrascrivere con il metodo reset (da provare)
  var resetPublicUserMenuStore = function resetPublicUserMenuStore() {
    /*Removing the cookie*/
    removeCookie("hashedEmail");
    name.value = "";
    email.value = "";
    mailConfirmed.value = null;
    favoriteIdList.value = [];
    requestsCounter.value = 0;
    savedSearchesCounter.value = 0;
    lastLoginDate.value = "";
    marketing.value = false;
    listingRequestsCount.value = 0;
    publicUserId.value = -1;
  };
  var getPublicUserMenuInfo = function getPublicUserMenuInfo() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return getMenuInfo();
          case 3:
            data = _context2.sent;
            window.dataLayer.push({
              user_id: data.publicUserId
            });
            initState(data);
            _context2.next = 11;
            break;
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            console.error(_context2.t0); //This should never happen!
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 8]]);
    }));
  };
  var addSaveSearch = function addSaveSearch(payload) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var email, title, hourly, resb, pushNotifications;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            email = payload.email, title = payload.title, hourly = payload.hourly, resb = payload.resb, pushNotifications = payload.pushNotifications;
            _context3.next = 3;
            return saveSearch(email, title, hourly, resb, pushNotifications);
          case 3:
            //The commit will happen iff there is no error
            increaseSavedSearches();
          case 4:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
  };
  //SAVE SEARCH
  var deleteSavedSearches = function deleteSavedSearches() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return deleteAllSaveSearch();
          case 3:
            savedSearchesCounter.value = 0;
            _context4.next = 9;
            break;
          case 6:
            _context4.prev = 6;
            _context4.t0 = _context4["catch"](0);
            console.error(_context4.t0); //This should never happen!
          case 9:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 6]]);
    }));
  };
  var deleteSaveSearchById = function deleteSaveSearchById(idToDelete) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return deleteSaveSearch(idToDelete);
          case 3:
            savedSearchesCounter.value -= 1;
            _context5.next = 9;
            break;
          case 6:
            _context5.prev = 6;
            _context5.t0 = _context5["catch"](0);
            console.error(_context5.t0);
          case 9:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[0, 6]]);
    }));
  };
  //FAVORITES
  var addFavorite = function addFavorite(id) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var res;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return addUserFavorite(id);
          case 2:
            res = _context6.sent;
            if (!res) {
              _context6.next = 8;
              break;
            }
            favoriteIdList.value.push(id);
            lastFavouriteModifiedId.value = id;
            _context6.next = 9;
            break;
          case 8:
            throw "We could not add the favorite to the user";
          case 9:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
  };
  var removeFavorite = function removeFavorite(id) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      var res;
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return deleteUserFavorite(id);
          case 2:
            res = _context7.sent;
            if (res) {
              _context7.next = 5;
              break;
            }
            throw "We could not remove the favorite!";
          case 5:
            try {
              favoriteIdList.value = favoriteIdList.value.filter(function (favoriteId) {
                return favoriteId !== id;
              });
              lastFavouriteModifiedId.value = id;
            } catch (error) {
              console.error(error);
            }
          case 6:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
  };
  var removeFavorites = function removeFavorites() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      var res;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return removeFavourites();
          case 2:
            res = _context8.sent;
            if (res) {
              _context8.next = 5;
              break;
            }
            throw "We could not remove all the favorites";
          case 5:
            favoriteIdList.value = [];
          case 6:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
  };
  //REQUESTS
  var sendAgencyContact = function sendAgencyContact(contact) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
      var res;
      return _regeneratorRuntime().wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return sendAgencyContactAsync(contact);
          case 2:
            res = _context9.sent;
            if (res && mailConfirmed.value)
              //If the email is not confirmed, we won't increase the counter!
              increaseRequestCounter();
            return _context9.abrupt("return", res);
          case 5:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
  };
  var sendConsultantAuctionContact = function sendConsultantAuctionContact(contact) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
      var res;
      return _regeneratorRuntime().wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return sendConsultantRequestContact(contact);
          case 2:
            res = _context10.sent;
            if (res && mailConfirmed.value)
              //If the email is not confirmed, we won't increase the counter!
              increaseRequestCounter();
            return _context10.abrupt("return", res);
          case 5:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
  };
  return {
    favoritesCounter: favoritesCounter,
    getFavoriteById: getFavoriteById,
    name: name,
    email: email,
    mailConfirmed: mailConfirmed,
    favoriteIdList: favoriteIdList,
    requestsCounter: requestsCounter,
    savedSearchesCounter: savedSearchesCounter,
    lastLoginDate: lastLoginDate,
    publicUserId: publicUserId,
    marketing: marketing,
    listingRequestsCount: listingRequestsCount,
    initState: initState,
    setMarketing: setMarketing,
    setSavedSearches: setSavedSearches,
    increaseSavedSearches: increaseSavedSearches,
    decreaseSavedSearchesCounter: decreaseSavedSearchesCounter,
    decreaseListingRequestsCounter: decreaseListingRequestsCounter,
    setUserFavorite: setUserFavorite,
    increaseRequestCounter: increaseRequestCounter,
    resetPublicUserMenuStore: resetPublicUserMenuStore,
    getPublicUserMenuInfo: getPublicUserMenuInfo,
    addSaveSearch: addSaveSearch,
    deleteSavedSearches: deleteSavedSearches,
    deleteSaveSearchById: deleteSaveSearchById,
    addFavorite: addFavorite,
    removeFavorite: removeFavorite,
    removeFavorites: removeFavorites,
    sendAgencyContact: sendAgencyContact,
    sendConsultantAuctionContact: sendConsultantAuctionContact,
    lastFavouriteModifiedId: lastFavouriteModifiedId
  };
});